module.exports = __webpack_public_path__ + "static/media/Siteplan_La-ban.38923ec5.svg";